// One counter, shared by the operator's nav badge and the queue page.
// The badge must not cost a request per screen: whoever mounts first fetches,
// and a triage action refreshes it so the number never lies.

import { useEffect, useState } from "react";
import { superAdminApi } from "./superadmin-api";

let current: number | null = null;
const listeners = new Set<(count: number | null) => void>();

/** Re-reads the open count from the API; a failure simply hides the badge. */
export async function refreshSignalementCount(): Promise<void> {
  try {
    const counts = await superAdminApi.signalementCounts();
    current = counts.open;
    listeners.forEach((listener) => listener(current));
  } catch {
    current = null;
    listeners.forEach((listener) => listener(null));
  }
}

/** How many reports still ask for a decision, or null while unknown. */
export function useSignalementCount(): number | null {
  const [count, setCount] = useState<number | null>(current);

  useEffect(() => {
    listeners.add(setCount);
    if (current === null) void refreshSignalementCount();

    return () => {
      listeners.delete(setCount);
    };
  }, []);

  return count;
}
